import React, { Component } from "react";
import LoadingInProgress from "../Shared/LoadingInProgress";

import SeminarsService from '../utils/SeminarsService'

import SeminarTable from "./SeminarTable";
import Pagination from "../Shared/pagination"

class ListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: { view: "list", assigned: "" },
      openItems: [],
      closedItems: [],
      hiddenItems: [],
      cancelledItems: [],
      inProgressItems: [],
      completedItems: []
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.handleViewClick = this.handleViewClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  onPageChange(currentPage) {
    this.setState({ currentPage }, () => this.fetchItems());
  }

  handleViewClick(id) {
    this.props.history.push(`/m1/tcs/${id}`);
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter, currentPage: 1 });
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchItems();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.filter !== prevState.filter) {
      this.fetchItems();
    }
  }

  fetchItems() {
    SeminarsService.index({ filter: this.state.filter }).then(data => {
      this.setState({
        loadingInProgress: false,
        openItems: data.results.filter((i) => i.status === 'open').sort((a, b) => a.at > b.at ? 1 : -1),
        inProgressItems: data.results.filter((i) => i.status === 'in_progress').sort((a, b) => a.at > b.at ? 1 : -1),
        completedItems: data.results.filter((i) => i.status === 'completed').sort((a, b) => a.at > b.at ? 1 : -1),
        hiddenItems: data.results.filter((i) => i.status === 'hidden').sort((a, b) => a.at > b.at ? 1 : -1),
        closedItems: data.results.filter((i) => i.status === 'closed').sort((a, b) => a.at > b.at ? 1 : -1),
        cancelledItems: data.results.filter((i) => i.status === 'cancelled').sort((a, b) => a.at > b.at ? 1 : -1)
      });
    });
  }

  render() {
    const { loadingInProgress } = this.state;

    return (
      <div>
        <h3 className="first-title">Seminars</h3>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-sm-9">

          </div>
          <div className="col-sm-3">
          {this.state.totalPages >= 2 ? (<div className='pull-right'>
            <Pagination
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onChange={this.onPageChange}
                />
            </div>) : <span></span>}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            {loadingInProgress ? (
              <LoadingInProgress message="Loading" />
            ) : (
              <div>
              <h4>Open for Registration</h4>
                <SeminarTable
                  items={this.state.openItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />

                <h4 style={{marginTop:'30px'}}>In Progress</h4>
                <SeminarTable
                  items={this.state.inProgressItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />
                <h4 style={{marginTop:'30px'}}>Closed for Public Registration</h4>
                <SeminarTable
                  items={this.state.closedItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />
                <h4 style={{marginTop:'30px'}}>Closed for All Registration</h4>
                <SeminarTable
                  items={this.state.hiddenItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />
                <h4 style={{marginTop:'30px'}}>Completed</h4>
                <SeminarTable
                  items={this.state.completedItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />

                <h4 style={{marginTop:'30px'}}>Cancelled</h4>
                <SeminarTable
                  items={this.state.cancelledItems}
                  onPageChange={this.onPageChange}
                  totalPages={this.state.totalPages}
                  currentPage={this.state.currentPage}
                />


              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default ListView;
